import React from 'react';
import SiteLayout from '../components/SiteLayout';
import PageHero from '../components/PageHero';
import CtaBand from '../components/CtaBand';
import ResearchGrid from '../research/ResearchGrid';
import { useResearchItems, useCtaResearch, usePageResearch } from '../data';

// §7.4 — Hero → research grid → CTA band.
export default function ResearchPage() {
  const page = usePageResearch();
  return (
    <SiteLayout navVariant="page">
      <PageHero accent={page.titleAccent} white={page.titleWhite} accentFirst lead={page.lead} variant="research" />
      <ResearchGrid items={useResearchItems()} />
      <CtaBand cta={useCtaResearch()} variant="research" />
    </SiteLayout>
  );
}
